/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-09 9:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  underlyingRuleManagement: 'Underlying Rule Management',
  encodingRuleManagement: 'Encoding Rule Management',
  searchForTheBaseRuleName: 'Search for The Base Rule Name',
  TheNameOfTheUnderlyingRule: 'Name',
  underlyingRuleDefinitions: 'Rule Definitions',
  numberOfDigits: 'Number of Digits',
  codeRules: 'Encoding Rules',
  encodingRules: 'Rules',
  searchForEncodingRuleNames: 'Search for Encoding Rule Names',
  theEncodingName: 'Name',
  ruleScope: 'Rule Scope',
  switch: 'Switch',
  registerAll: 'Register All',
  ruleBreakdown: 'Rule Breakdown',
  associateAttributeRules: 'Associate Attribute Rules',
  referenceTheUnderlyingRule: 'Reference The Underlying Rule',
  propertyName: 'Name',
  customRules: 'Custom Rules',
  theDefaultSetting: 'The Default Setting',
  openRegister:
    'Enable All Registration: Register All Named Objects in The Model, Where The Tag of The Matching Rule is Filled in With The Relevant Attribute According to The Attribute Rule.',
  closeRegister:
    'Close All Registration: Registers a Tag According to The Rule That is Open in The Current Rule Switch.',
  editTheUnderlyingRule: 'Edit The Underlying Rule',
  addedBasicRules: 'Added Basic Rules',
  ruleName: 'Name',
  ruleDefinitions: 'Rule Definitions',
  pleaseFillInTheRegularExpression: 'Please Fill in The Regular Expression',
  editTheEncodingRules: 'Edit The Encoding Rules',
  addedEncodingRules: 'Added Encoding Rules',
  pleaseSelect: '--Please Select--',
  attributeEncodingRules: 'Attribute Encoding Rules',
  reg: 'Please Enter a Valid Regular Expression',
  pleaseSelectTheDataYouWantToDelete: 'Please Select The Data You Want to Delete',
  whetherToDeleteTheUnderlyingRule: 'Whether to Delete The Underlying Rule',
  deletionSuccessful: 'Deletion Successful!',
  theStartIndexCannotBeGreaterThanTheEndIndex:
    'The Start Index Cannot be Greater Than The End Index',
  theEncodingRuleCannotBeEmpty: 'The Encoding Rule Cannot be Empty~',
  whetheToDeleteTheEncodingRule: 'Whether to Delete The Encoding Rule',
}
